import { graphql, HeadProps, PageProps } from 'gatsby';
import React from 'react';
import If from '../../components/If';
import Layout from '../../components/Layout';
import ModuleProductPage from '../../components/ModuleProductPage';
import ModuleProductPageWide from '../../components/ModuleProductPageWide';
import PluginProductPage from '../../components/PluginProductPage';
import { SeoBasic, SeoProduct } from '../../components/Seo';

export function ProductPage(props: any) {
  const wide =
    props.handle === 'xm' ||
    props.handle === 'xer-mixa-expando-expandi' ||
    props.productType === 'Apparel' ||
    props.productType === 'Swag' ||
    //props.handle === '3u-techno-machine' ||

    //props.handle === '6u-techno-machine' ||

    props.productType === 'Pedal';

  const software =
    props.productType === 'Software' || props.tags.includes('freequel');

  const tags = props.tags.filter(
    (t: string) => t !== 'New' && !t.endsWith('hp')
  );

  return (
    <>
      <If value={software}>
        <PluginProductPage {...props}></PluginProductPage>
      </If>
      <If value={wide}>
        <ModuleProductPageWide {...props}></ModuleProductPageWide>
      </If>
      <If value={!wide && !software}>
        <ModuleProductPage {...props}></ModuleProductPage>
      </If>
    </>
  );
}

export default function Product(props: PageProps<Queries.ProductQuery>) {
  return (
    <Layout>
      <ProductPage {...props.data.neProduct} />
    </Layout>
  );
}

export function Head(props: HeadProps<Queries.ProductQuery>) {
  const product = props.data.neProduct as any;

  const variant = product.variants.nodes[0];

  return (
    <>
      <SeoBasic
        image={product?.images[0].url}
        imageAlt={product?.images[0].altText}
        title={product.title}
        path={props.location.pathname}
        description={product.description}
      />
      <SeoProduct
        amount={variant?.priceV2?.amount}
        currency={variant?.priceV2?.currencyCode}
      />
    </>
  );
}

//todo image updates

export const query = graphql`
  query Product($handle: String) {
    neProduct(handle: { eq: $handle }) {
      pid
      availableForSale
      box
      bundleAndSave
      vendor
      title
      tags
      descriptionHtml
      description
      sample_pack_buy_url
      product_card_description
      productType
      presets
      modulargrid
      conservation
      quickstart
      images {
        altText
        url
        src_sm
        src_md
        src_lg
        src_xl
      }
      videos {
        alt
        url
      }
      manual_link
      learn_more_links
      id
      handle
      featuresandspecs
      description
      seo {
        title
        description
      }
      quotes {
        name
        quote
      }
      sounds {
        name
        src
      }
      variants {
        nodes {
          id
          title
          availableForSale
          image {
            url
            altText
            src_sm
            src_md
            src_lg
            src_xl
          }
          priceV2 {
            amount
            currencyCode
          }
        }
      }
    }
  }
`;
